import { CSSProperties } from 'react';

export const notificationContainerStyles: CSSProperties = {
  position: 'relative',
  zIndex: 9999999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  maxWidth: '400px',
  background: '#FFF',
  borderRadius: '26px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  padding: '15px',
  gap: '12px',
  border: '1px solid #ddd'
};

export const notificationImgStyles: CSSProperties = {
  objectFit: 'cover',
  width: '100%',
  height: '100%',
  borderRadius: '50%' // Circular image
};

export const notificationImgContainerStyles: CSSProperties = {
  width: '60px',
  height: '60px',
  position: 'relative'
};

export const notificationTextContainerStyle: CSSProperties = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
};

export const notificationIconContainerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '40px'
};

export const notificationsHeadlineStyle: CSSProperties = {
  fontSize: '18px',
  fontWeight: '600',
  color: '#393737',
  margin: 0
};

export const notificationSubtextStyle: CSSProperties = {
  fontSize: '14px',
  color: '#717070',
  margin: 0,
  marginTop: '2px'
};
